import { useEffect, useRef, useState } from 'react';

import { ANIMATION_TIMING, READING_TIMING } from './constants';
import { EntriesWrapper, Letter, StyledEntry, Wrapper } from './styles';

const TextEntry = ({ children = '' }) => {
  const element = useRef(null);
  const wordSegments = Array.from(children);

  return (
    <StyledEntry ref={element}>
      {wordSegments.map((textCharacter) => (
        // We use Math.random() to ensure the elements are not reused
        // This is critical to achieve the desired effect
        <Letter key={Math.random()}>{textCharacter}</Letter>
      ))}
    </StyledEntry>
  );
};

const CycleText = ({ entries: sourceEntries }) => {
  const [entries, setEntries] = useState(sourceEntries);

  useEffect(() => {
    const interval = setInterval(() => {
      setEntries((currentEntries) => {
        const firstEntry = currentEntries.shift();
        currentEntries.push(firstEntry);
        return [].concat(currentEntries);
      });
    }, ANIMATION_TIMING + READING_TIMING);

    return () => clearInterval(interval);
  }, []);

  return (
    <Wrapper>
      <EntriesWrapper>
        {entries.map((entry) => (
          // We use Math.random() to ensure the elements are not reused
          // This is critical to achieve the desired effect
          <TextEntry key={Math.random()}>{entry}</TextEntry>
        ))}
      </EntriesWrapper>
    </Wrapper>
  );
};

export default CycleText;
